"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetCampaignsStatus = exports.setCampaignsCountryId = exports.loadCampaignsFail = exports.loadCampaignsSuccess = exports.loadCampaignsRequest = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'COMMON/GIFT_CREATE/CAMPAIGNS';
var loadCampaignsRequest = (0, _reduxAct.createAction)("".concat(PREFIX, "/LOAD_CAMPAIGNS_REQUEST"));
exports.loadCampaignsRequest = loadCampaignsRequest;
var loadCampaignsSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/LOAD_CAMPAIGNS_SUCCESS"));
exports.loadCampaignsSuccess = loadCampaignsSuccess;
var loadCampaignsFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/LOAD_CAMPAIGNS_FAIL"));
exports.loadCampaignsFail = loadCampaignsFail;
var setCampaignsCountryId = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_CAMPAIGNS_COUNTRY_ID"));
exports.setCampaignsCountryId = setCampaignsCountryId;
var resetCampaignsStatus = (0, _reduxAct.createAction)("".concat(PREFIX, "/RESET_CAMPAIGNS_STATUS"));
exports.resetCampaignsStatus = resetCampaignsStatus;